module.exports = __webpack_public_path__ + "static/media/Bebas.3ef73ff4.TTF";